/**
 * Resource Library (Super Admin) query and mutation helpers using Gen 2 typed client.
 */
import { authClient } from "../utils/amplifyClient";

// ---------------------------------------------------------------------------
// Query helpers
// ---------------------------------------------------------------------------

export async function listAllLibraryPlanTemplates() {
    const { data } = await authClient.models.LibraryPlanTemplate.list();
    return data;
}

export async function listAllLibraryTopicTemplates() {
    const { data } = await authClient.models.LibraryTopicTemplate.list();
    return data;
}

export async function listAllHelpSupportDocs() {
    const { data } = await authClient.models.HelpSupportDoc.list();
    return data;
}

export async function listAllFormTemplateGroups() {
    const { data } = await authClient.models.FormTemplateGroup.list();
    return data;
}

export async function listFormTemplatesByGroup(groupId: string) {
    const { data } = await authClient.models.FormTemplate.list();
    return data.filter(t => t.formTemplateGroupID === groupId);
}

export async function listAllCompanyOwners() {
    const { data } = await authClient.models.CompanyOwner.list();
    return data;
}

// ---------------------------------------------------------------------------
// Mutation helpers — LibraryPlanTemplate
// ---------------------------------------------------------------------------

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function createLibraryPlanTemplate(input: any) {
    const { data } = await authClient.models.LibraryPlanTemplate.create(input);
    return data;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function updateLibraryPlanTemplate(input: any) {
    const { data } = await authClient.models.LibraryPlanTemplate.update(input);
    return data;
}

export async function deleteLibraryPlanTemplate(id: string) {
    const { data } = await authClient.models.LibraryPlanTemplate.delete({ id });
    return data;
}

// ---------------------------------------------------------------------------
// Mutation helpers — LibraryTopicTemplate
// ---------------------------------------------------------------------------

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function createLibraryTopicTemplate(input: any) {
    const { data } = await authClient.models.LibraryTopicTemplate.create(input);
    return data;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function updateLibraryTopicTemplate(input: any) {
    const { data } = await authClient.models.LibraryTopicTemplate.update(input);
    return data;
}

export async function deleteLibraryTopicTemplate(id: string) {
    const { data } = await authClient.models.LibraryTopicTemplate.delete({ id });
    return data;
}

// ---------------------------------------------------------------------------
// Mutation helpers — HelpSupportDoc
// ---------------------------------------------------------------------------

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function createHelpSupportDoc(input: any) {
    const { data } = await authClient.models.HelpSupportDoc.create(input);
    return data;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function updateHelpSupportDoc(input: any) {
    const { data } = await authClient.models.HelpSupportDoc.update(input);
    return data;
}

export async function deleteHelpSupportDoc(id: string) {
    const { data } = await authClient.models.HelpSupportDoc.delete({ id });
    return data;
}

// ---------------------------------------------------------------------------
// Mutation helpers — FormTemplateGroup
// ---------------------------------------------------------------------------

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function createFormTemplateGroup(input: any) {
    const { data } = await authClient.models.FormTemplateGroup.create(input);
    return data;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function updateFormTemplateGroup(input: any) {
    const { data } = await authClient.models.FormTemplateGroup.update(input);
    return data;
}

export async function deleteFormTemplateGroup(id: string) {
    const { data } = await authClient.models.FormTemplateGroup.delete({ id });
    return data;
}

// ---------------------------------------------------------------------------
// Mutation helpers — FormTemplate
// ---------------------------------------------------------------------------

export async function deleteFormTemplate(id: string) {
    const { data } = await authClient.models.FormTemplate.delete({ id });
    return data;
}
